import React, { FC } from 'react'
import CreateVendorContainer from 'containers/Vendors/CreateVendor'

const CreateVendorPage: FC = () => <CreateVendorContainer />

export default CreateVendorPage
